import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  GetUserOrderReferralDiscountRequestType,
  GetUserOrderReferralDiscountResponseType
} from '../../../services/PaymentServices/APIService/types';

import usePaymentServices from '../usePaymentServices';

interface UseCheckReferralCodeInterface {
  checkReferralCodeApi: UseMutateAsyncFunction<
    GetUserOrderReferralDiscountResponseType,
    unknown,
    GetUserOrderReferralDiscountRequestType,
    unknown
  >;
  error: string | null;
  status: MutationStatus;
}

const useCheckReferralCode = (): UseCheckReferralCodeInterface => {
  const { paymentServices } = usePaymentServices();

  const checkReferralCode = (
    requestObject: GetUserOrderReferralDiscountRequestType
  ) => {
    return paymentServices.checkReferralCode(requestObject);
  };

  const { mutateAsync, error, status } = useMutation(checkReferralCode, {
    mutationKey: ['checkReferralCode']
  });

  return {
    checkReferralCodeApi: mutateAsync,
    error: error ? getAPIErrorMessage(error) : null,
    status
  };
};

export { useCheckReferralCode };
